import { useEffect } from "react";
import { useConfigurationApi } from "../hooks/useConfigurationApi";
import { useSessionId } from "../hooks/useSessionId";
/**
 * Prevents the session from expiring
 * - requires {@linkcode ConfigurationController}
 * @category Controller
 * @export
 * @param {HeartBeatControllerProps}
 * @returns {null}
 */
export function HeartbeatController({ interval = 60e3, }) {
    const cfgApi = useConfigurationApi();
    const sessionid = useSessionId();
    useEffect(() => {
        let handle = 0;
        // if the session  is started, attach the heartbeat
        if (sessionid) {
            handle = window.setInterval(() => {
                cfgApi.keepConfigurationAlive({ id: sessionid });
            }, interval);
        }
        return () => {
            if (handle) {
                window.clearInterval(handle);
            }
        };
    }, [cfgApi, sessionid, interval]);
    return null;
}
//# sourceMappingURL=HeartbeatController.js.map